/* begin general import */
import Close16 from "@carbon/icons-react/es/close/16";
import Send16 from "@carbon/icons-react/es/send/16";
import {
  Col,
  Popconfirm,
  Row,
  Spin,
  Switch,
  TreeSelect,
  Tooltip,
  Select as SelectAntd,
  Tag,
} from "antd";
import { APP_USER_ROUTE } from "config/route-consts";
import { AppUser } from "models/AppUser";
import { AppUserSiteMapping } from "models/AppUserSiteMapping";
import { SexFilter } from "models/Sex";
import { Site, SiteFilter } from "models/Site";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  LayoutCell,
  LayoutHeader,
  OneLineText,
  StandardTable,
  Tabs,
  TreeSelect as TreeReact3l,
} from "react3l-ui-library";
import DatePicker from "react3l-ui-library/build/components/Calendar/DatePicker/DatePicker";
import FormItem from "react3l-ui-library/build/components/FormItem";
import InputText from "react3l-ui-library/build/components/Input/InputText";
import Select from "react3l-ui-library/build/components/Select/SingleSelect/Select";
import { appUserRepository } from "repositories/app-user-repository";
import { utilService } from "services/common-services/util-service";
import {
  ModelActionEnum,
  detailService,
} from "services/page-services/detail-service";
import { fieldService } from "services/page-services/field-service";
import {
  Add24,
  ChevronDown16,
  ChevronUp16,
  Delete24,
  Time16,
} from "@carbon/icons-react";
import { Tabs as TabsAntd } from "antd";
import { ColumnProps } from "antd/lib/table";
import { formatNumber } from "helpers/number";
import _, { cloneDeep, debounce } from "lodash";
import { FieldModelFilter } from "models/FieldModel";
import { PermissionOperatorFilter } from "models/PermissionOperator";
import appMessageService from "services/common-services/app-message-service";
import { webService } from "services/common-services/web-service";
import nameof from "ts-nameof.macro";
import { v4 as uuidv4 } from "uuid";
import AppUserPermissionModal from "./AppUserPermissionModal";
import { OrganizationFilter } from "models/Organization/OrganizationFilter";
import { masterService } from "services/page-services/master-service";
import { authorizationService } from "services/common-services/authorization-service";
import { API_APP_USER_PREFIX } from "config/api-consts";
import { MasterData } from "models/MasterData/MasterData";
import classNames from "classnames";

const TabPane = TabsAntd.TabPane;

function AppUserPermission() {
  const [translate] = useTranslation();
  const [checkArrModalEmpty, setCheckArrModalEmpty] = useState(false);
  const { handleGoHistory } = masterService.useMasterAction(APP_USER_ROUTE);
  const { validAction } = authorizationService.useAuthorizedAction(
    APP_USER_ROUTE.split("/")[APP_USER_ROUTE.split("/").length - 1],
    API_APP_USER_PREFIX
  );
  //Khởi tạo lấy ra model
  const { model, dispatch } = detailService.useModel<AppUser>(AppUser);

  const { isDetail } = detailService.useGetIsDetail<AppUser>(
    appUserRepository.get,
    dispatch
  );

  const {
    handleChangeDateField,
    handleChangeAllField,
    handleChangeSingleField,
    handleChangeTreeField,
    handleChangeSelectField,
  } = fieldService.useField(model, dispatch);

  const { handleGoMaster } = detailService.useActionsDetail<AppUser>(
    model,
    appUserRepository.updateResource,
    handleChangeAllField,
    APP_USER_ROUTE
  );

  const [isSite, setIsSite] = React.useState<boolean>(true);
  const [appUserSiteMappings, setAppUserSiteMappings] = React.useState<
    AppUserSiteMapping[]
  >([]);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const handleCloseRoleView = React.useCallback(() => {
    setIsOpenModal(false);
  }, []);

  const [showDetail, setShowDetail] = React.useState<boolean>(false);
  const [appUser, setAppUser] = useState<AppUser>(new AppUser());
  const [arrFilterRoleCode, setArrFilterRoleCode] = React.useState([]);
  const [arrFilterRoleSite, setArrFilterRoleSite] = React.useState([]);
  const [arrRoleSiteAfterFilter, setArrRoleSiteAfterFilter] = React.useState(
    []
  );
  const [arrRoleCodeAfterFilter, setArrRoleCodeAfterFilter] = React.useState(
    []
  );
  const [arrAfterFilter, setArrAfterFilter] = React.useState([]);
  // const [selectTreeData, setSelectTreeData] = useState<MasterData>([]);
  const [isFirstLoad, setIsFirstLoad] = useState(false);
  const [dataValueStandardTable, setDataValueStandardTable] = useState<any>([]);
  const [
    dataValueStandardTableNotConvert,
    setDataValueStandardTableNotConvert,
  ] = useState<any>([]);
  const [subscription] = webService.useSubscription();

  const { notifyUpdateItemSuccess, notifyUpdateItemError } =
    appMessageService.useCRUDMessage();

  const [checkSave, setCheckSave] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [arrAppUserResourceDataFilter, setArrAppUserResourceDataFilter] =
    React.useState([]);

  const [selectedCode, setSelectedCode] = useState(undefined);
  const [selectedSite, setSelectedSite] = useState(undefined);

  const handleChangeStatus = React.useCallback(
    (checked) => {
      const newModel = { ...model };
      if (checked) {
        newModel.statusId = 1;
      } else {
        newModel.statusId = 0;
      }
      handleChangeAllField(newModel);
    },
    [handleChangeAllField, model]
  );

  const handleOpenRoleView = React.useCallback(() => {
    setIsOpenModal(true);
  }, []);

  const handleSaveRole = React.useCallback(
    (list) => {
      const modelHere = _.cloneDeep(model);
      // const dataValueStandardTableHere = _.cloneDeep(dataValueStandardTable);
      // const dataValueStandardTableNotConvertHere = _.cloneDeep(
      //   dataValueStandardTableNotConvert
      // );
      // Sau khi save ở model role, sẽ trả ra những thằng mình chọn trong model ở đây là list
      if (list && list?.length > 0) {
        //     Tạo ra một mảng lấy ra những thằng có roleId của dữ liệu model(model.appUserRoles)
        //  , tất cả thằng có roleId là thằng cha, còn không có sẽ là con, loại bỏ con để lặp thằng bị trùng
        let arrModelWithRoleId = model?.appUserRoles?.filter(
          (item: any) => item.roleId
        );
        let listId = list?.map((item: any) => item?.id); // Lấy ra 1 arr chỉ có id của list
        if (!arrModelWithRoleId) {
          // Thêm mới lần đầu tiên khi chưa có vai trò sẽ không có arrModelWithRoleId, nên check trùng qua list
          modelHere.appUserRoles = [];
          for (let i = 0; i < list?.length; i++) {
            modelHere?.appUserRoles?.push({
              roleId: list[i]?.id,
              assignmentTypeId: list[i]?.assignmentType?.id,
              assignmentType: {
                id: list[i]?.assignmentType?.id,
                code: list[i]?.assignmentType?.code,
                name: list[i]?.assignmentType?.name,
                generalInformations: [],
                generalWarnings: [],
                generalErrors: [],
              },
              role: {
                id: list[i]?.id,
                code: list[i]?.code,
                name: list[i]?.name,
                statusId: list[i]?.statusId,
                site: {
                  id: list[i]?.site?.id,
                  code: list[i]?.site?.code,
                  name: list[i]?.site?.name,
                  description: list[i]?.site?.description,
                  lightIcon: list[i]?.site?.lightIcon,
                  lightLogo: list[i]?.site?.lightLogo,
                  darkIcon: list[i]?.site?.darkIcon,
                  darkLogo: list[i]?.site?.darkLogo,
                  siteTypeId: list[i]?.site?.siteTypeId,
                  colorCode: list[i]?.site?.colorCode,
                  isDisplay: list[i]?.site?.isDisplay,
                  siteType: list[i]?.site?.siteType,
                  informations: list[i]?.site?.informations,
                  warnings: list[i]?.site?.warnings,
                  errors: list[i]?.site?.errors,
                  disabled: list[i]?.site?.disabled,
                  generalInformations: [],
                  generalWarnings: [],
                  generalErrors: [],
                },
                informations: list[i]?.informations,
                warnings: list[i]?.warnings,
                errors: list[i]?.errors,
                disabled: list[i]?.disabled,
                generalInformations: [],
                generalWarnings: [],
                generalErrors: [],
              },
              appUserResource: null,
              generalInformations: [],
              generalWarnings: [],
              generalErrors: [],
            });
          }
          dispatch({
            type: ModelActionEnum.UPDATE,
            payload: {
              appUserRoles: modelHere?.appUserRoles,
            } as AppUser,
          });
        }
        // Từ lần thêm thứ 2 sau khi thêm mới ở model và bảng phân quyền dữ liệu theo vai trò đã có dữ liệu, check trùng theo arrModelWithRoleId
        else {
          let arrUserRolesHere = [];
          // Điều kiện này là điều kiện khi lưu mà không back lại về màn master luôn mà vẫn ở màn hiện tại
          // , điều kiện này để khi xóa ở model và ấn lưu thì sẽ xóa ở phần table
          // Hiện tại đk này có thể sẽ không nhảy vào do lưu giờ đã chuyển về màn master luôn
          if (listId.length < arrModelWithRoleId?.length) {
            if (checkArrModalEmpty === false) {
              arrUserRolesHere = modelHere?.appUserRoles?.filter((item: any) =>
                listId?.includes(item?.roleId || item?.parentId)
              );
            } else {
              modelHere.appUserRoles = [];
              for (let i = 0; i < list?.length; i++) {
                modelHere?.appUserRoles?.push({
                  roleId: list[i]?.id,
                  assignmentTypeId: list[i]?.assignmentType?.id,
                  assignmentType: {
                    id: list[i]?.assignmentType?.id,
                    code: list[i]?.assignmentType?.code,
                    name: list[i]?.assignmentType?.name,
                    generalInformations: [],
                    generalWarnings: [],
                    generalErrors: [],
                  },
                  role: {
                    id: list[i]?.id,
                    code: list[i]?.code,
                    name: list[i]?.name,
                    statusId: list[i]?.statusId,
                    site: {
                      id: list[i]?.site?.id,
                      code: list[i]?.site?.code,
                      name: list[i]?.site?.name,
                      description: list[i]?.site?.description,
                      lightIcon: list[i]?.site?.lightIcon,
                      lightLogo: list[i]?.site?.lightLogo,
                      darkIcon: list[i]?.site?.darkIcon,
                      darkLogo: list[i]?.site?.darkLogo,
                      siteTypeId: list[i]?.site?.siteTypeId,
                      colorCode: list[i]?.site?.colorCode,
                      isDisplay: list[i]?.site?.isDisplay,
                      siteType: list[i]?.site?.siteType,
                      informations: list[i]?.site?.informations,
                      warnings: list[i]?.site?.warnings,
                      errors: list[i]?.site?.errors,
                      disabled: list[i]?.site?.disabled,
                      generalInformations: [],
                      generalWarnings: [],
                      generalErrors: [],
                    },
                    siteId: list[i]?.site?.id,
                    informations: list[i]?.informations,
                    warnings: list[i]?.warnings,
                    errors: list[i]?.errors,
                    disabled: list[i]?.disabled,
                    generalInformations: [],
                    generalWarnings: [],
                    generalErrors: [],
                  },
                  appUserResource: null,
                  generalInformations: [],
                  generalWarnings: [],
                  generalErrors: [],
                });
              }
              arrUserRolesHere = modelHere.appUserRoles;
            }
            dispatch({
              type: ModelActionEnum.UPDATE,
              payload: {
                appUserRoles: arrUserRolesHere,
              } as AppUser,
            });
          }
          // Điều kiện này để check, khi xóa 1 thằng ở model và thêm mới 1 thằng mới ở model,
          // vì thế length của listId chọn ở model và length của arrModelWithRoleId sẽ bằng nhau
          // (listId.length === arrModelWithRoleId.length)
          else {
            // Tạo ra một arr chỉ chứa roleId của arrModelWithRoleId
            let arrRoleId = arrModelWithRoleId?.map((i: any) => i?.roleId);
            for (let i = 0; i < listId?.length; i++) {
              // Nếu arrRoleId có roleId không chứa id của listId thì ta sẽ đẩy thằng mới vào model.appUserRoles
              if (!arrRoleId?.includes(listId[i])) {
                modelHere?.appUserRoles?.push({
                  roleId: list[i]?.id,
                  assignmentTypeId: list[i]?.assignmentType?.id,
                  assignmentType: {
                    id: list[i]?.assignmentType?.id,
                    code: list[i]?.assignmentType?.code,
                    name: list[i]?.assignmentType?.name,
                    generalInformations: [],
                    generalWarnings: [],
                    generalErrors: [],
                  },
                  role: {
                    id: list[i]?.id,
                    code: list[i]?.code,
                    name: list[i]?.name,
                    statusId: list[i]?.statusId,
                    site: {
                      id: list[i]?.site?.id,
                      code: list[i]?.site?.code,
                      name: list[i]?.site?.name,
                      description: list[i]?.site?.description,
                      lightIcon: list[i]?.site?.lightIcon,
                      lightLogo: list[i]?.site?.lightLogo,
                      darkIcon: list[i]?.site?.darkIcon,
                      darkLogo: list[i]?.site?.darkLogo,
                      siteTypeId: list[i]?.site?.siteTypeId,
                      colorCode: list[i]?.site?.colorCode,
                      isDisplay: list[i]?.site?.isDisplay,
                      siteType: list[i]?.site?.siteType,
                      informations: list[i]?.site?.informations,
                      warnings: list[i]?.site?.warnings,
                      errors: list[i]?.site?.errors,
                      disabled: list[i]?.site?.disabled,
                      generalInformations: [],
                      generalWarnings: [],
                      generalErrors: [],
                    },
                    siteId: list[i]?.site?.id,
                    informations: list[i]?.informations,
                    warnings: list[i]?.warnings,
                    errors: list[i]?.errors,
                    disabled: list[i]?.disabled,
                    generalInformations: [],
                    generalWarnings: [],
                    generalErrors: [],
                  },
                  appUserResource: null,
                  generalInformations: [],
                  generalWarnings: [],
                  generalErrors: [],
                });
              }
            }
            // Khi này modelHere.appUserRoles sẽ thừa những thằng mà đã xóa ở listId, nên ta sẽ filter để loại bỏ
            arrUserRolesHere = modelHere?.appUserRoles?.filter((item: any) =>
              listId?.includes(item?.roleId || item?.parentId)
            );
            dispatch({
              type: ModelActionEnum.UPDATE,
              payload: {
                appUserRoles: arrUserRolesHere,
              } as AppUser,
            });
          }
        }
        setIsOpenModal(false);
      } else {
        // if no store selected, remove all contents
        appUser.appUserRoles = [];
        setAppUser({
          ...appUser,
        });
        modelHere.appUserRoles = [];
        dispatch({
          type: ModelActionEnum.UPDATE,
          payload: {
            appUserRoles: modelHere?.appUserRoles,
          } as AppUser,
        });
        setIsOpenModal(false);
      }
      // dataValueStandardTableHere.push([]);
      // dataValueStandardTableNotConvertHere.push([]);
      // setDataValueStandardTable(dataValueStandardTableHere);
      // setDataValueStandardTableNotConvert(dataValueStandardTableNotConvertHere);
    },
    [
      appUser,
      dispatch,
      model,
      checkArrModalEmpty,
      // dataValueStandardTable,
      // dataValueStandardTableNotConvert,
    ]
  );

  const handleChangeSiteMapping = React.useCallback(
    (index) => {
      return (check: boolean) => {
        appUserSiteMappings[index].enabled = check;
        setAppUserSiteMappings([...appUserSiteMappings]);
        dispatch({
          type: ModelActionEnum.UPDATE,
          payload: {
            appUserSiteMappings: appUserSiteMappings,
          } as AppUser,
        });
      };
    },
    [appUserSiteMappings, dispatch]
  );

  const handleChangeSelectSearch = React.useCallback(
    (key: string) => (item: any) => {
      switch (key) {
        case "code": {
          // Trường hợp chọn select
          if (item) {
            const lowerCaseSearchTerm = item.toLowerCase();
            const appUserRolesHere = cloneDeep(model?.appUserRoles);
            const arrAfterFilterHere = cloneDeep(arrAfterFilter);
            // Nếu chọn site trước và đã có dữ liệu
            if (
              arrAfterFilterHere?.length > 0 &&
              arrRoleSiteAfterFilter?.length > 0
            ) {
              const arrFilter = arrAfterFilterHere.filter((item: any) => {
                return item?.role?.code
                  .toLowerCase()
                  .includes(lowerCaseSearchTerm);
              });
              // Nếu tìm thấy theo tìm kiếm
              if (arrFilter?.length > 0) {
                setArrAfterFilter(arrFilter);
              }
              //Nếu không tìm thấy
              else {
                setArrAfterFilter(undefined);
              }
            }
            //Nếu chỉ chọn mỗi code
            else {
              const arrFilter = appUserRolesHere.filter((item: any) => {
                return item?.role?.code
                  .toLowerCase()
                  .includes(lowerCaseSearchTerm);
              });
              setArrAfterFilter(arrFilter);
            }
            // khi chọn site nào thì sẽ push tất cả site được chọn vào arrRoleCode, không tính các điều kiện khác
            const arrFilter = appUserRolesHere.filter((item: any) => {
              return item?.role?.code
                .toLowerCase()
                .includes(lowerCaseSearchTerm);
            });
            setArrRoleCodeAfterFilter(arrFilter);
          }
          //Nếu như xóa phần tìm kiếm code
          else {
            setArrRoleCodeAfterFilter([]);
            // Nếu như trước đi chọn site
            if (arrRoleSiteAfterFilter?.length > 0) {
              setArrAfterFilter(arrRoleSiteAfterFilter);
            }
            // Nếu chưa chọn site
            else {
              setArrAfterFilter([]);
            }
          }
          break;
        }
        case "site": {
          if (item) {
            const lowerCaseSearchTerm = item.toLowerCase();
            const appUserRolesHere = cloneDeep(model?.appUserRoles);
            const arrAfterFilterHere = cloneDeep(arrAfterFilter);
            // Nếu chọn code trước và đã có dữ liệu
            if (
              arrAfterFilter?.length > 0 &&
              arrRoleCodeAfterFilter?.length > 0
            ) {
              const arrFilter = arrAfterFilterHere.filter((item: any) => {
                return item?.role?.site?.name
                  .toLowerCase()
                  .includes(lowerCaseSearchTerm);
              });
              // Nếu tìm thấy theo tìm kiếm
              if (arrFilter?.length > 0) {
                setArrAfterFilter(arrFilter);
              }
              //Nếu không tìm thấy
              else {
                setArrAfterFilter(undefined);
              }
            }
            //Nếu chỉ chọn mỗi site
            else {
              const arrFilter = appUserRolesHere.filter((item: any) => {
                return item?.role?.site?.name
                  .toLowerCase()
                  .includes(lowerCaseSearchTerm);
              });
              setArrAfterFilter(arrFilter);
            }
            // khi chọn site nào thì sẽ push tất cả site được chọn vào arrRoleSite, không tính các điều kiện khác
            const arrFilter = appUserRolesHere.filter((item: any) => {
              return item?.role?.site?.name
                .toLowerCase()
                .includes(lowerCaseSearchTerm);
            });
            setArrRoleSiteAfterFilter(arrFilter);
          }
          //Nếu như xóa phần tìm kiếm site
          else {
            setArrRoleSiteAfterFilter([]);
            // Nếu như trước đi chọn code
            if (arrRoleCodeAfterFilter?.length > 0) {
              setArrAfterFilter(arrRoleCodeAfterFilter);
            }
            // Nếu chưa chọn code
            else {
              setArrAfterFilter([]);
            }
          }
          break;
        }
      }
    },
    [
      model?.appUserRoles,
      arrAfterFilter,
      arrRoleCodeAfterFilter,
      arrRoleSiteAfterFilter,
    ]
  );

  const handleAddRow = React.useCallback(
    (index: number, id: any, value: any) => {
      const dataValueStandardTableHere = _.cloneDeep(dataValueStandardTable);
      const dataValueStandardTableNotConvertHere = _.cloneDeep(
        dataValueStandardTableNotConvert
      );
      const rowIdHere = uuidv4();
      let modelHere = _.cloneDeep(model);
      let plus = 0;
      for (let i = 0; i < modelHere?.appUserRoles?.length; i++) {
        // Trường hợp xoa thằng cha, hiện tại đã không cho xóa thằng cha nữa
        // Khi chọn xóa thằng cha, nếu có roleId của thằng chả = với parentId của thằng con, thì plus sẽ + 1, để xóa tất cả thằng con cùng thằng cha
        if (
          modelHere?.appUserRoles[index]?.roleId ===
          modelHere?.appUserRoles[i]?.parentId &&
          modelHere?.appUserRoles[index]?.assignmentType?.id ===
          modelHere?.appUserRoles[i]?.assignmentType?.id
        ) {
          plus = plus + 1;
        }
        // Nếu như chọn thằng con thì không làm gì cả, để splice tự xóa chính nó
      }
      modelHere?.appUserRoles?.splice(index + 1 + plus, 0, {
        index: index + plus,
        parentId: value?.roleId,
        assignmentTypeId: value?.assignmentType?.id,
        assignmentType: value?.assignmentType,
        role: value?.role,
        rowId: rowIdHere,
        roleId: 0,
        appUserResource: null,
        generalInformations: [],
        generalWarnings: [],
        generalErrors: [],
      });
      dataValueStandardTableHere.splice(index + 1 + plus, 0, []);
      dataValueStandardTableNotConvertHere.splice(index + 1 + plus, 0, []);
      setDataValueStandardTable(dataValueStandardTableHere);
      setDataValueStandardTableNotConvert(dataValueStandardTableNotConvertHere);
      if (arrAfterFilter?.length > 0) {
        const indexArrAfterFilter = _.findIndex(arrAfterFilter, {
          rowId: value?.rowId,
        });
        const arrAfterFilterHere = cloneDeep(arrAfterFilter);
        let plusArrAfterFilter = 0;
        for (let i = 0; i < arrAfterFilterHere?.length; i++) {
          if (
            arrAfterFilterHere[indexArrAfterFilter]?.roleId ===
            arrAfterFilterHere[i]?.parentId &&
            arrAfterFilterHere[indexArrAfterFilter]?.assignmentType?.id ===
            arrAfterFilterHere[i]?.assignmentType?.id
          ) {
            plusArrAfterFilter = plusArrAfterFilter + 1;
          }
        }
        arrAfterFilterHere?.splice(
          indexArrAfterFilter + 1 + plusArrAfterFilter,
          0,
          {
            index: indexArrAfterFilter + plusArrAfterFilter,
            parentId: value?.roleId,
            assignmentTypeId: value?.assignmentType?.id,
            assignmentType: value?.assignmentType,
            role: value?.role,
            roleId: 0,
            rowId: rowIdHere,
            appUserResource: null,
            generalInformations: [],
            generalWarnings: [],
            generalErrors: [],
          }
        );
        setArrAfterFilter(arrAfterFilterHere);
      }
      dispatch({
        type: ModelActionEnum.UPDATE,
        payload: {
          appUserRoles: modelHere.appUserRoles,
        } as AppUser,
      });
    },
    [
      model,
      dispatch,
      dataValueStandardTable,
      dataValueStandardTableNotConvert,
      arrAfterFilter,
    ]
  );

  const handleChangeConditionApi = React.useCallback(
    (
      index: number,
      masterEntityId: number,
      fieldEntityId: number,
      isTree: number,
      isDelete?: boolean
    ) => {
      // Hàm này mục đích sử dụng là sau khi chọn lại điều kiện sẽ call lại api single list của giá trị để lấy lại giá trị đúng cho phần select
      const dataValueStandardTableHere = _.cloneDeep(dataValueStandardTable);
      const dataValueStandardTableNotConvertHere = _.cloneDeep(
        dataValueStandardTableNotConvert
      );
      const arr: any = [];
      setIsLoading(true);
      // Nếu như thay đổi điều kiện chứ không xóa
      if (!isDelete) {
        setIsLoading(true);
        appUserRepository
          .singleListMasterData({
            id: {},
            masterEntityId: {
              equal: masterEntityId,
            },
            entityId: {},
            code: {},
            name: {},
            createdAt: {},
            updatedAt: {},
            statusId: {},
            path: {},
            level: {},
            parentId: {},
            fieldEntityId: {
              equal: fieldEntityId,
            },
            search: "",
          })
          .subscribe((data: MasterData[]) => {
            setIsLoading(false);

            const arrValue: any = [];
            for (let i = 0; i < model?.appUserRoles?.length; i++) {
              arrValue.push({
                fieldEntityId: model?.appUserRoles[i]?.appUserResource
                  ?.fieldEntityId
                  ? model?.appUserRoles[i]?.appUserResource?.fieldEntityId
                  : fieldEntityId,
                masterEntityId: model?.appUserRoles[i]?.appUserResource
                  ?.fieldEntity?.masterEntityId
                  ? model?.appUserRoles[i]?.appUserResource?.fieldEntity
                    ?.masterEntityId
                  : masterEntityId,
                isTree: model?.appUserRoles[i]?.appUserResource?.fieldEntity
                  ?.masterEntity?.isTree
                  ? model?.appUserRoles[i]?.appUserResource?.fieldEntity
                    ?.masterEntity?.isTree
                  : isTree,
                index: i,
              });
            }
            //Nếu là dạng TreeSelct multi
            if (isTree === 1) {
              const tree: MasterData = [];
              const map: MasterData = {};
              // Foreach đầu tiên để tạo ra 1 obj chưa tất cả dữ liệu của cha vào con
              data.forEach((data) => {
                map[data.id] = {
                  ...data,
                  children: [],
                  title: data.title,
                  value: data.id,
                  fieldEntityId: arrValue[index]?.fieldEntityId,
                  masterEntityId: arrValue[index]?.masterEntityId,
                  index: arrValue[index]?.index,
                };
                arr.push({
                  ...data,
                  children: [],
                  title: data.title,
                  value: data.id,
                  fieldEntityId: arrValue[index]?.fieldEntityId,
                  masterEntityId: arrValue[index]?.masterEntityId,
                  index: arrValue[index]?.index,
                });
              });
              data.forEach((data) => {
                //Trường hợp data là thằng con sẽ tìm đến id của thằng cha, rồi obj cha sẽ push data này vào children của nó
                if (data.parentId !== null) {
                  map[data.parentId].children.push(map[data.id]);
                }
                //Trường hợp là thằng cha thì ta sẽ push nó vào trong mảng
                else {
                  tree.push(map[data.id]);
                }
              });
              dataValueStandardTableNotConvertHere[index] = arr;
              dataValueStandardTableHere[index] = tree;
              setDataValueStandardTable(dataValueStandardTableHere);
              setDataValueStandardTableNotConvert(
                dataValueStandardTableNotConvertHere
              );
            }
            //Trường hợp Select Multi
            else {
              for (let z = 0; z < data.length; z++) {
                data[z].value = data[z].id;
                data[z].fieldEntityId = arrValue[index]?.fieldEntityId;
                data[z].masterEntityId = arrValue[index]?.masterEntityId;
                if (z === 0) {
                  data[z].index = arrValue[index]?.index;
                }
              }
              dataValueStandardTableNotConvertHere[index] = data;
              dataValueStandardTableHere[index] = data;
              setDataValueStandardTable(dataValueStandardTableHere);
              setDataValueStandardTableNotConvert(
                dataValueStandardTableNotConvertHere
              );
            }
          });
      }
      //Trường hợp xóa điều kiện
      else {
        setIsLoading(false);
        dataValueStandardTableHere.splice(index, 1, []);
        dataValueStandardTableNotConvertHere.splice(index, 1, []);
        setDataValueStandardTable(dataValueStandardTableHere);
        setDataValueStandardTableNotConvert(
          dataValueStandardTableNotConvertHere
        );
      }
    },
    [
      dataValueStandardTable,
      dataValueStandardTableNotConvert,
      model?.appUserRoles,
    ]
  );

  const handleChangeRole = React.useCallback(
    (data: any, index: number, key: string) => (id: any, item: any) => {
      let modelHere = _.cloneDeep(model);
      // Nếu như thay đổi điều kiện
      if (key === "CONDITION") {
        if (item) {
          // Trường hợp mới đầu khi chưa chọn điều kiện
          if (modelHere?.appUserRoles[index]?.appUserResource === null) {
            // Vì appUserResource === null nên sẽ gán nó bằng {} giống với dữ liệu truyền lên là 1 kiểu object
            modelHere.appUserRoles[index].appUserResource = {};
            // Tương tự gán appUserResource.fieldEntity = {} giống với dữ liệu truyền lên là 1 kiểu object
            modelHere.appUserRoles[index].appUserResource.fieldEntity = {};
            modelHere.appUserRoles[index].appUserResource.fieldEntity.id =
              item?.id;
            modelHere.appUserRoles[index].appUserResource.fieldEntityId =
              item?.id;
            modelHere.appUserRoles[
              index
            ].appUserResource.fieldEntity.masterEntityId = item?.masterEntityId;
            modelHere.appUserRoles[index].appUserResource.fieldEntity.code =
              item?.code;
            modelHere.appUserRoles[index].appUserResource.fieldEntity.name =
              item?.name;
            modelHere.appUserRoles[index].appUserResource.fieldEntity.statusId =
              item?.statusId;
            modelHere.appUserRoles[
              index
            ].appUserResource.fieldEntity.fieldName = item?.fieldName;
            modelHere.appUserRoles[
              index
            ].appUserResource.fieldEntity.createdAt = item?.createdAt;
            modelHere.appUserRoles[
              index
            ].appUserResource.fieldEntity.updatedAt = item?.updatedAt;
            modelHere.appUserRoles[
              index
            ].appUserResource.fieldEntity.masterEntity = {
              code: item?.masterEntity?.code,
              name: item?.name,
              isTree: item?.masterEntity?.isTree,
              id: item?.masterEntityId,
            };
            modelHere.appUserRoles[index].appUserResource.masterDatas =
              undefined;
            handleChangeConditionApi(
              index,
              item?.masterEntityId,
              id,
              item?.masterEntity?.isTree
            );
          } else {
            // Trường hợp đã có điều kiện và ta thay đổi nó
            modelHere.appUserRoles[index].appUserResource.fieldEntity = {};
            modelHere.appUserRoles[index].appUserResource.fieldEntity.id =
              item?.id;
            modelHere.appUserRoles[index].appUserResource.fieldEntityId =
              item?.id;
            modelHere.appUserRoles[
              index
            ].appUserResource.fieldEntity.masterEntityId = item?.masterEntityId;
            modelHere.appUserRoles[index].appUserResource.fieldEntity.code =
              item?.code;
            modelHere.appUserRoles[index].appUserResource.fieldEntity.name =
              item?.name;
            modelHere.appUserRoles[
              index
            ].appUserResource.fieldEntity.fieldName = item?.fieldName;
            modelHere.appUserRoles[index].appUserResource.fieldEntity.statusId =
              item?.statusId;
            modelHere.appUserRoles[
              index
            ].appUserResource.fieldEntity.createdAt = item?.createdAt;
            modelHere.appUserRoles[
              index
            ].appUserResource.fieldEntity.updatedAt = item?.updatedAt;
            modelHere.appUserRoles[
              index
            ].appUserResource.fieldEntity.masterEntity = {
              code: item?.masterEntity?.code,
              name: item?.name,
              isTree: item?.masterEntity?.isTree,
              id: item?.masterEntityId,
            };
            modelHere.appUserRoles[index].appUserResource.masterDatas = null;
            handleChangeConditionApi(
              index,
              item?.masterEntityId,
              id,
              item?.masterEntity?.isTree
            );
          }
        }
        // Trường hợp xóa bỏ luôn điều kiện ở thao tác dấu x ở select
        else {
          handleChangeConditionApi(
            index,
            item?.masterEntityId,
            id,
            item?.masterEntity?.isTree,
            true
          );
          modelHere.appUserRoles[index].appUserResource = null;
          // setAppUserResourceDataFilter(undefined)
        }
      }
      // Trường hợp thay đổi mã thao  tác
      // else if (key === "PERMISSIONOPERATOR") {
      //   if (item) {
      //     // Nếu như đã chọn điều kiện và thay đổi mã thao tác
      //     if (modelHere?.appUserRoles[index]?.appUserResource !== null) {
      //       modelHere.appUserRoles[index].appUserResource.permissionOperator =
      //         {};
      //       modelHere.appUserRoles[
      //         index
      //       ].appUserResource.permissionOperator.id = item?.id;
      //       modelHere.appUserRoles[index].appUserResource.permissionOperatorId =
      //         item?.id;
      //       modelHere.appUserRoles[
      //         index
      //       ].appUserResource.permissionOperator.code = item?.code;
      //       modelHere.appUserRoles[
      //         index
      //       ].appUserResource.permissionOperator.name = item?.name;
      //       modelHere.appUserRoles[
      //         index
      //       ].appUserResource.permissionOperator.fieldTypeId =
      //         item?.fieldTypeId;
      //       modelHere.appUserRoles[
      //         index
      //       ].appUserResource.permissionOperator.fieldType = item?.fieldType;
      //     }
      //   }
      //   // Trường hợp xóa bỏ luôn mã thao tác ở thao tác dấu x ở select
      //   else {
      //     // Gán mã thao tác và cả giá trị = null
      //     modelHere.appUserRoles[index].appUserResource.permissionOperator =
      //       null;
      //     modelHere.appUserRoles[index].appUserResource.masterData = null;
      //   }
      // }
      // Trường hợp thay đổi giá trị
      // Vẫn để đẩy để sau có dùng thì sử dụng, nhưng hiện tại sẽ không gọi đến phần else này
      else {
        if (item) {
          if (modelHere?.appUserRoles[index]?.appUserResource !== null) {
            modelHere.appUserRoles[index].appUserResource.masterDatas = [{}];
            modelHere.appUserRoles[index].appUserResource.masterDatas[0].code =
              item?.code;
            modelHere.appUserRoles[index].appUserResource.masterDatas[0].id =
              item?.id;
            modelHere.appUserRoles[
              index
            ].appUserResource.masterDatas[0].masterEntityId =
              item?.masterEntityId;
            modelHere.appUserRoles[index].appUserResource.masterDatas[0].name =
              item?.name;
            modelHere.appUserRoles[
              index
            ].appUserResource.masterDatas[0].entityId = item?.entityId;
            modelHere.appUserRoles[index].appUserResource.value =
              item?.id?.toString();
          }
        } else {
          modelHere.appUserRoles[index].appUserResource.masterDatas = undefined;
        }
      }
      dispatch({
        type: ModelActionEnum.UPDATE,
        payload: {
          appUserRoles: modelHere.appUserRoles,
        } as AppUser,
      });
    },
    [dispatch, model, handleChangeConditionApi]
  );

  const handleSaveModelHere = React.useCallback(() => {
    setIsLoading(true);
    let arrCheck = [];
    // Điều kiện validate
    for (let i = 0; i < model?.appUserRoles?.length; i++) {
      // Thằng con phải chọn hết cả điều kiện, mã thao tác, giá trị thì mới cho lưu
      // Thằng cha thì nếu không chọn gì, hoặc đã chọn thì phải chọn đủ cả điều kiện, mã thao tác, giá trị thì mới cho lưu
      if (
        (model?.appUserRoles[i]?.appUserResource?.fieldEntity &&
          model?.appUserRoles[i]?.appUserResource?.masterDatas?.length > 0) ||
        // &&
        // model?.appUserRoles[i]?.appUserResource?.permissionOperator
        (!model?.appUserRoles[i]?.appUserResource?.fieldEntity &&
          !model?.appUserRoles[i]?.parentId &&
          !model?.appUserRoles[i + 1]?.parentId)

        // && (!model?.appUserRoles[i + 1] || !model?.appUserRoles[i + 1]?.parentId)
      ) {
        arrCheck.push(true);
      } else {
        arrCheck.push(false);
        // let errMess: ArgsProps = { message: "Chưa chọn đủ thông tin!" }
        notifyUpdateItemError();
        setIsLoading(false);
      }
      setCheckSave(arrCheck);
    }
    // Nếu như check tất cả validate đều đúng thì cho lưu
    if (arrCheck.every((i) => i === true) === true) {
      // Thêm index vào dữ liệu
      for (let i = 0; i < model?.appUserRoles?.length; i++) {
        model.appUserRoles[i].index = i;
      }
      subscription.add(
        appUserRepository.updateResource(model).subscribe({
          next: (item: any) => {
            dispatch({
              type: ModelActionEnum.UPDATE,
              payload: {
                appUserRoles: item?.appUserRoles,
              } as AppUser,
            });
            setArrAfterFilter([]);
            notifyUpdateItemSuccess();
            setIsLoading(false);
            handleChangeSelectSearch("code")(undefined);
            handleChangeSelectSearch("site")(undefined);
            setSelectedCode(undefined);
            setSelectedSite(undefined);
            // window.history.back();
          },
          error: (error: any) => {
            setIsLoading(false);
            if (error.response && error.response.status === 400) {
              handleChangeAllField(error.response?.data);
              notifyUpdateItemError();
            }
          },
        })
      );
    }
  }, [
    model,
    notifyUpdateItemError,
    subscription,
    dispatch,
    notifyUpdateItemSuccess,
    handleChangeSelectSearch,
    handleChangeAllField,
  ]);

  const handleDeleteRow = React.useCallback(
    (index: any, value?: any) => {
      const modelHere = _.cloneDeep(model);
      const dataValueStandardTableHere = _.cloneDeep(dataValueStandardTable);
      const dataValueStandardTableNotConvertHere = _.cloneDeep(
        dataValueStandardTableNotConvert
      );
      let plus = 1;
      // Trường hợp xóa thằng cha, hiện tại sẽ không nhảy vào điều kiện này do giờ đã check k được xóa cha
      // Thêm mới lúc đầu thì sẽ không có id, nên check nếu như không có id nhưng có roleId thì sẽ là cha(Cha luôn có roleId và con không có)
      // Nếu như có Id thì sẽ là cha, vì con luôn lưu id = 0
      if (
        modelHere?.appUserRoles[index]?.id ||
        (!modelHere?.appUserRoles[index]?.id &&
          !modelHere?.appUserRoles[index]?.parentId)
      ) {
        for (let i = 0; i < modelHere?.appUserRoles?.length; i++) {
          // check chọn thằng cha vã những thằng có parentId = với roleId của cha sẽ là con để cộng thêm thằng plus để xóa thằng cha sẽ xóa cả con
          if (
            modelHere?.appUserRoles[index]?.roleId ===
            modelHere?.appUserRoles[i + 1]?.parentId &&
            modelHere?.appUserRoles[index]?.assignmentType?.id ===
            modelHere?.appUserRoles[i + 1]?.assignmentType?.id
          ) {
            plus = plus + 1;
          }
        }
      }
      // Xóa thằng con
      else {
        plus = 1;
      }
      modelHere?.appUserRoles?.splice(index, plus);
      dataValueStandardTableHere.splice(index, plus);
      dataValueStandardTableNotConvertHere.splice(index, plus);
      setDataValueStandardTable(dataValueStandardTableHere);
      setDataValueStandardTableNotConvert(dataValueStandardTableNotConvertHere);
      if (arrAfterFilter?.length > 0) {
        const indexArrAfterFilter = _.findIndex(arrAfterFilter, {
          rowId: value?.rowId,
        });
        const arrAfterFilterHere = cloneDeep(arrAfterFilter);
        let plusArrAfterFilter = 1;
        if (
          arrAfterFilter[indexArrAfterFilter]?.id ||
          (!arrAfterFilter[indexArrAfterFilter]?.id &&
            !arrAfterFilter[indexArrAfterFilter]?.parentId)
        ) {
          for (let i = 0; i < arrAfterFilterHere?.length; i++) {
            if (
              arrAfterFilterHere[indexArrAfterFilter]?.roleId ===
              arrAfterFilterHere[i + 1]?.parentId &&
              arrAfterFilterHere[indexArrAfterFilter]?.assignmentType?.id ===
              arrAfterFilterHere[i + 1]?.assignmentType?.id
            ) {
              plusArrAfterFilter = plusArrAfterFilter + 1;
            }
          }
        }
        // Xóa thằng con
        else {
          plusArrAfterFilter = 1;
        }
        arrAfterFilterHere?.splice(indexArrAfterFilter, plusArrAfterFilter);
        setArrAfterFilter(arrAfterFilterHere);
      }
      dispatch({
        type: ModelActionEnum.UPDATE,
        payload: {
          appUserRoles: modelHere?.appUserRoles,
        } as AppUser,
      });
    },
    [
      dispatch,
      model,
      dataValueStandardTable,
      dataValueStandardTableNotConvert,
      arrAfterFilter,
    ]
  );

  const onChangeAppUserResourceDataFilter = React.useCallback(
    (index: number, model: any) => (arrIndex: any, arrItem: any) => {
      const oldValues =
        model?.appUserRoles[index]?.appUserResource?.masterDatas || [];
      arrItem.map(
        (x: any) =>
        (x.editable = oldValues.filter(
          (item: any) => item.id === x.id
        )[0]?.editable)
      );
      if (oldValues.length > arrItem.length) {
        const removedValues = oldValues.filter(
          (item: any) => !arrItem.some((newItem: any) => newItem.id === item.id)
        );

        if (removedValues.length > 0) {
          const canDelete = removedValues.every(
            (value: any) =>
              value.editable === true ||
              value.editable === null ||
              value.editable === undefined
          );
          if (!canDelete) {
            notifyUpdateItemError({
              message: "Không được xóa CostCenter mặc định",
            });
            return;
          }
        }
      }

      const modelHere = _.cloneDeep(model);
      modelHere.appUserRoles[index].appUserResource.masterDatas = arrItem;
      dispatch({
        type: ModelActionEnum.UPDATE,
        payload: {
          appUserRoles: modelHere?.appUserRoles,
        } as AppUser,
      });
    },
    [dispatch, notifyUpdateItemError]
  );

  const debouncedFilterListMaterialType = debounce(
    (value: string, index: number, model: any) => {
      const arrAppUserResourceDataFilterHere = _.cloneDeep(
        arrAppUserResourceDataFilter
      );
      setIsLoading(true);
      if (value) {
        appUserRepository
          .singleListMasterData({
            search: value,
            fieldEntityId: {
              equal: model.appUserRoles[index].appUserResource.fieldEntityId,
            },
            masterEntityId: {
              equal:
                model.appUserRoles[index].appUserResource.fieldEntity
                  .masterEntityId,
            },
          })
          .subscribe((res: any) => {
            arrAppUserResourceDataFilterHere[index] = res;
            setArrAppUserResourceDataFilter(arrAppUserResourceDataFilterHere);
            setIsLoading(false);
          });
      } else {
        arrAppUserResourceDataFilterHere[index] = [];
        setArrAppUserResourceDataFilter(arrAppUserResourceDataFilterHere);
        setIsLoading(false);
      }
    },
    300
  );

  const onSearchAppUserResourceDataFilter = React.useCallback(
    (index: number, model: any) => (value: string) => {
      debouncedFilterListMaterialType(value, index, model);
    },
    [debouncedFilterListMaterialType]
  );

  const onChangeTreeSelect = React.useCallback(
    (index: number, data: any) => (item: any) => {
      // Hàm này để thay đổi phần giá trị
      // Kiểm tra mảng selectDataTreeNotConvert nếu như chứa các id mà ta truyền vào khi chọn thì tạo ra 1 mảng mới chỉ có những thằng obj đó
      const selectData = dataValueStandardTableNotConvert[index]?.filter(
        (i: any) => item.includes(i?.id)
      );
      const modelHere = _.cloneDeep(model);
      // const parentId = data.parentId;
      if (arrAfterFilter?.length === 0) {
        modelHere.appUserRoles[index].appUserResource.masterDatas = selectData;
        modelHere.appUserRoles[index].appUserResource.values = selectData?.map(
          (i: any) => i.id
        );
        // Đoạn for này để push phần tử con giá trị BE trả về vào phần tử cha
        // for (let i = 0; i < modelHere?.appUserRoles?.length; i++) {
        //   if (
        //     !modelHere?.appUserRoles[i]?.parentId &&
        //     modelHere?.appUserRoles[i]?.roleId === parentId
        //   ) {
        //     for (let z = 0; z < selectData?.length; z++) {
        //       if (selectData[z]?.businessAreaOrganization) {
        //         if (modelHere.appUserRoles[i].appUserResource.masterDatas && modelHere.appUserRoles[i].appUserResource.values) {
        //           modelHere.appUserRoles[i].appUserResource.masterDatas = [
        //             ...modelHere.appUserRoles[i].appUserResource.masterDatas,
        //             selectData[z]?.businessAreaOrganization,
        //           ];
        //           modelHere.appUserRoles[i].appUserResource.values = [
        //             ...modelHere.appUserRoles[i].appUserResource.values,
        //             selectData[z]?.businessAreaOrganization?.id,
        //           ];
        //           model.appUserRoles[i].appUserResource.masterDatas[z].value =
        //             model.appUserRoles[i].appUserResource.masterDatas[z].id;
        //           model.appUserRoles[i].appUserResource.masterDatas[z].label =
        //             model.appUserRoles[i].appUserResource.masterDatas[z].name;
        //           model.appUserRoles[i].appUserResource.masterDatas[z].title =
        //             model.appUserRoles[i].appUserResource.masterDatas[z].name;
        //         }
        //         else {
        //           modelHere.appUserRoles[i].appUserResource.masterDatas = [
        //             selectData[z]?.businessAreaOrganization,
        //           ];
        //           modelHere.appUserRoles[i].appUserResource.values = [
        //             selectData[z]?.businessAreaOrganization?.id,
        //           ];
        //         }
        //       }
        //     }
        //   }
        // }
      } else {
        const indexHere = _.findIndex(model.appUserRoles, {
          rowId: data?.rowId,
        });
        modelHere.appUserRoles[indexHere].appUserResource.masterDatas =
          selectData;
        modelHere.appUserRoles[indexHere].appUserResource.values =
          selectData?.map((i: any) => i.id);
      }
      dispatch({
        type: ModelActionEnum.UPDATE,
        payload: {
          appUserRoles: modelHere?.appUserRoles,
        } as AppUser,
      });
    },
    [dataValueStandardTableNotConvert, model, dispatch, arrAfterFilter]
  );

  React.useEffect(() => {
    if (model && isFirstLoad === false) {
      if (model?.appUserRoles?.length > 0) {
        const selectTreeDataHere: any = [];
        const selectTreeDataConvertHere: any = [];
        const arrValue: any = [];
        const promises: any = [];
        const arr: any = [];
        setIsLoading(true);
        //Vòng for này để lấy ra tất cả object của model?.appUserRoles[i]?.appUserResource
        for (let i = 0; i < model?.appUserRoles?.length; i++) {
          arrValue.push({
            fieldEntityId:
              model?.appUserRoles[i]?.appUserResource?.fieldEntityId,
            masterEntityId:
              model?.appUserRoles[i]?.appUserResource?.fieldEntity
                ?.masterEntityId,
            isTree:
              model?.appUserRoles[i]?.appUserResource?.fieldEntity?.masterEntity
                ?.isTree,
            index: i,
          });
        }
        // Sau đó check trùng để chạy for api không bị trùng những thằng đã có fieldEntityId và masterEntityId giống nhau
        const arrNotDuplicate = _.uniqWith(
          arrValue,
          (obj1: any, obj2) =>
            obj1?.fieldEntityId === obj2?.fieldEntityId &&
            obj1?.masterEntityId === obj2?.masterEntityId
        );
        for (let i = 0; i < arrNotDuplicate?.length; i++) {
          const arrHere: any = [];
          const promise = new Promise((rs, rj) => {
            if (arrNotDuplicate[i]?.isTree === 1) {
              // Với trường hợp là SelectTree
              appUserRepository
                .singleListMasterData({
                  id: {},
                  masterEntityId: {
                    equal: arrNotDuplicate[i]?.masterEntityId,
                  },
                  entityId: {},
                  code: {},
                  name: {},
                  createdAt: {},
                  updatedAt: {},
                  statusId: {},
                  path: {},
                  level: {},
                  parentId: {},
                  fieldEntityId: {
                    equal: arrNotDuplicate[i]?.fieldEntityId,
                  },
                  search: "",
                })
                .subscribe((data: MasterData[]) => {
                  const tree: MasterData = [];
                  const map: MasterData = {};
                  // Foreach đầu tiên để tạo ra 1 obj chưa tất cả dữ liệu của cha vào con
                  data.forEach((data) => {
                    map[data.id] = {
                      ...data,
                      children: [],
                      title: data.title,
                      value: data.id,
                      fieldEntityId: arrNotDuplicate[i]?.fieldEntityId,
                      masterEntityId: arrNotDuplicate[i]?.masterEntityId,
                      index: arrNotDuplicate[i]?.index,
                    };
                    arrHere.push({
                      ...data,
                      children: [],
                      title: data.title,
                      value: data.id,
                      fieldEntityId: arrNotDuplicate[i]?.fieldEntityId,
                      masterEntityId: arrNotDuplicate[i]?.masterEntityId,
                      index: arrNotDuplicate[i]?.index,
                    });
                  });
                  data.forEach((data) => {
                    //Trường hợp data là thằng con sẽ tìm đến id của thằng cha, rồi obj cha sẽ push data này vào children của nó
                    if (data.parentId !== null) {
                      map[data.parentId].children.push(map[data.id]);
                    }
                    //Trường hợp là thằng cha thì ta sẽ push nó vào trong mảng
                    else {
                      tree.push(map[data.id]);
                    }
                  });
                  if (tree?.length > 0) {
                    selectTreeDataConvertHere.push(tree);
                    arr.push(arrHere);
                  } else {
                    selectTreeDataConvertHere.push([
                      {
                        fieldEntityId: arrNotDuplicate[i]?.fieldEntityId,
                        masterEntityId: arrNotDuplicate[i]?.masterEntityId,
                      },
                    ]);
                  }
                  rs(() => {
                    return promise;
                  });
                });
            } else {
              // Với trường hợp là Select nhiều nhưng không phải tree
              appUserRepository
                .singleListMasterData({
                  id: {},
                  masterEntityId: {
                    equal: arrNotDuplicate[i]?.masterEntityId,
                  },
                  entityId: {},
                  code: {},
                  name: {},
                  createdAt: {},
                  updatedAt: {},
                  statusId: {},
                  path: {},
                  level: {},
                  parentId: {},
                  fieldEntityId: {
                    equal: arrNotDuplicate[i]?.fieldEntityId,
                  },
                  search: "",
                })
                .subscribe((data: MasterData[]) => {
                  if (data?.length > 0) {
                    for (let z = 0; z < data.length; z++) {
                      data[z].value = data[z].id;
                      data[z].fieldEntityId = arrNotDuplicate[i]?.fieldEntityId;
                      data[z].masterEntityId =
                        arrNotDuplicate[i]?.masterEntityId;
                      if (z === 0) {
                        data[z].index = arrNotDuplicate[i]?.index;
                      }
                      arrHere.push(data[z]);
                    }
                    selectTreeDataHere.push(data);
                    // selectDataTreeNotConvertHere.push(data);
                  } else {
                    selectTreeDataHere.push([
                      {
                        fieldEntityId: arrNotDuplicate[i]?.fieldEntityId,
                        masterEntityId: arrNotDuplicate[i]?.masterEntityId,
                      },
                    ]);
                    arrHere.push({
                      fieldEntityId: arrNotDuplicate[i]?.fieldEntityId,
                      masterEntityId: arrNotDuplicate[i]?.masterEntityId,
                    });
                  }
                  arr.push(arrHere);
                  rs(() => {
                    return promise;
                  });
                });
            }
          });
          promises.push(promise);
        }
        // selectDataTreeNotConvertHere mảng này phục vụ cho việc chọn dữ liệu khi thay đổi giá trị

        Promise.all(promises).then(() => {
          // Dữ liệu của phần treeselect chọn nhiều
          const selectTreeDataConvertHereClone = _.cloneDeep(
            selectTreeDataConvertHere
          );
          // Dữ liệu của phần select thường chọn nhiều
          const selectTreeDataHereClone = _.cloneDeep(selectTreeDataHere);
          const dataConcat = selectTreeDataConvertHereClone.concat(
            selectTreeDataHereClone
          );
          const selectDataTreeNotConvertPromise = [];
          const dataValueStandardTableHere = [];
          // Kiểm tra trong mảng arrValue là mảng gồm tất cả obj model?.appUserRoles, nếu như thiếu thằng nào thì sẽ đẩy vào mảng dataValueStandardTableHere
          // Vì ta đã call api check trùng, nên sau khi call xong phải đẩy lại để đủ dữ liệu
          for (let i = 0; i < arrValue?.length; i++) {
            for (let z = 0; z < dataConcat?.length; z++) {
              if (
                arrValue[i]?.masterEntityId ===
                dataConcat[z]["0"]?.masterEntityId &&
                arrValue[i]?.fieldEntityId === dataConcat[z]["0"]?.fieldEntityId
              ) {
                dataValueStandardTableHere.push(dataConcat[z]);
              }
            }
          }
          for (let i = 0; i < arrValue?.length; i++) {
            for (let z = 0; z < arr?.length; z++) {
              if (
                arrValue[i]?.masterEntityId === arr[z]["0"]?.masterEntityId &&
                arrValue[i]?.fieldEntityId === arr[z]["0"]?.fieldEntityId
              ) {
                selectDataTreeNotConvertPromise.push(arr[z]);
              }
            }
          }
          setDataValueStandardTableNotConvert(selectDataTreeNotConvertPromise);
          setDataValueStandardTable(dataValueStandardTableHere);
          setIsFirstLoad(true);
          setIsLoading(false);
        });
      }
    }
  }, [isFirstLoad, model, arrAfterFilter]);

  React.useEffect(() => {
    if (!isDetail && isSite) {
      appUserRepository
        .listSite(new SiteFilter())
        .subscribe((mapping: Site[]) => {
          mapping.forEach((site: Site) => {
            appUserSiteMappings.push({
              ...new AppUserSiteMapping(),
              site,
              siteId: site?.id,
            });
          });
          setAppUserSiteMappings(appUserSiteMappings);
          dispatch({
            type: ModelActionEnum.UPDATE,
            payload: {
              appUserSiteMappings: appUserSiteMappings,
            } as AppUser,
          });
        });
      setIsSite(false);
    }
    if (isDetail && isSite) {
      if (model?.appUserSiteMappings && model?.appUserSiteMappings.length > 0) {
        const appUserSite: AppUserSiteMapping[] = model?.appUserSiteMappings;
        setAppUserSiteMappings([...appUserSite]);
        setIsSite(false);
      }
    }
  }, [appUserSiteMappings, dispatch, isDetail, isSite, model]);

  React.useEffect(() => {
    if (model) {
      if (model?.appUserRoles?.length > 0) {
        const arrHere = [];
        const arrFilterRoleCodeHere = [];
        const arrFilterRoleSiteHere: any = [];
        for (let i = 0; i < model?.appUserRoles?.length; i++) {
          arrHere.push([]);
          arrFilterRoleCodeHere.push({
            id: model?.appUserRoles[i]?.role?.id,
            code: model?.appUserRoles[i]?.role?.code,
            value: model?.appUserRoles[i]?.role?.code,
            label: model?.appUserRoles[i]?.role?.code,
          });
          arrFilterRoleSiteHere.push({
            name: model?.appUserRoles[i]?.role?.site?.name,
            value: model?.appUserRoles[i]?.role?.site?.name,
            label: model?.appUserRoles[i]?.role?.site?.name,
          });
        }
        const arrFilterRoleCodeUniqueHere = _.uniqBy(
          arrFilterRoleCodeHere,
          function (item: any) {
            return item.id;
          }
        );
        const arrFilterRoleSiteUniqueHere = _.uniqBy(
          arrFilterRoleSiteHere,
          function (item: any) {
            return item.name;
          }
        );
        setArrFilterRoleCode(arrFilterRoleCodeUniqueHere);
        setArrFilterRoleSite(arrFilterRoleSiteUniqueHere);
        setArrAppUserResourceDataFilter(arrHere);
      }
    }
  }, [model]);

  const columns: ColumnProps<AppUser>[] = React.useMemo(
    () => [
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("general.columns.index")}
          />
        ),
        width: 40,
        ellipsis: true,
        key: "stt",
        dataIndex: "stt",
        render(...params: [number, AppUser, number]) {
          return (
            <LayoutCell
              orderType="left"
              tableSize="md"
              className={
                params[1].parentId ? "background-color-td-child-dxg" : ""
              }
            >
              <OneLineText
                value={formatNumber(params[2] + 1)}
                countCharacters={1000}
              />
            </LayoutCell>
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.code")}
          />
        ),
        key: "role",
        dataIndex: "role",
        width: 130,
        render(...params: [any, AppUser, number]) {
          return (
            <LayoutCell
              orderType="left"
              tableSize="sm"
              className={
                params[1].parentId ? "background-color-td-child-dxg" : ""
              }
            >
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  params[1],
                  nameof(params[1].role)
                )}
                message={params[1].errors?.role}
              >
                <OneLineText value={params[0]?.code} countCharacters={50} />
              </FormItem>
            </LayoutCell>
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.name")}
          />
        ),
        key: "role",
        dataIndex: "role",
        ellipsis: true,
        width: 130,
        render(...params: [any, AppUser, number]) {
          return (
            <LayoutCell
              orderType="left"
              tableSize="sm"
              className={
                params[1].parentId ? "background-color-td-child-dxg" : ""
              }
            >
              <OneLineText value={params[0]?.name} countCharacters={50} />
            </LayoutCell>
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.type")}
          />
        ),
        key: "assignmentType",
        dataIndex: "assignmentType",
        ellipsis: true,
        width: 100,
        render(...params: [any, AppUser, number]) {
          return (
            <LayoutCell
              orderType="left"
              tableSize="sm"
              className={
                params[1].parentId ? "background-color-td-child-dxg" : ""
              }
            >
              <OneLineText value={params[0]?.name} countCharacters={50} />
            </LayoutCell>
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.subSystem")}
          />
        ),
        key: "role",
        dataIndex: "role",
        width: 100,
        render(...params: [any, AppUser, number]) {
          return (
            <LayoutCell
              orderType="left"
              tableSize="sm"
              className={
                params[1].parentId ? "background-color-td-child-dxg" : ""
              }
            >
              <OneLineText value={params[0]?.site?.name} countCharacters={50} />
            </LayoutCell>
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.condition")}
          />
        ),
        key: "appUserResource",
        dataIndex: "appUserResource",
        width: 180,
        render(...params: [any, AppUser, number]) {
          const indexHere = _.findIndex(model.appUserRoles, {
            rowId: params[1]?.rowId,
          });
          let ids: any = [];
          if (arrAfterFilter?.length === 0) {
            model?.appUserRoles?.forEach((item: AppUser) => {
              if (item?.assignmentType?.code !== "SPECIFICITY") {
                if (!params[1]?.parentId) {
                  if (
                    (item?.parentId === params[1]?.roleId &&
                      !item?.roleId &&
                      !params[1]?.parentId) ||
                    (item?.roleId === params[1]?.roleId &&
                      !item?.parentId &&
                      !params[1]?.parentId)
                  )
                    if (item?.appUserResource?.fieldEntityId) {
                      ids?.push(item?.appUserResource?.fieldEntityId);
                    }
                }
                if (params[1]?.parentId) {
                  if (
                    (item?.roleId === params[1]?.parentId &&
                      !params[1]?.roleId &&
                      !item?.parentId) ||
                    (item?.parentId === params[1]?.parentId &&
                      !params[1]?.roleId &&
                      !item?.roleId)
                  )
                    if (item?.appUserResource?.fieldEntityId) {
                      ids?.push(item?.appUserResource?.fieldEntityId);
                    }
                }
              }
            });
          } else {
            arrAfterFilter?.forEach((item: AppUser) => {
              if (item?.assignmentType?.code !== "SPECIFICITY") {
                if (!params[1]?.parentId) {
                  if (
                    (item?.parentId === params[1]?.roleId &&
                      !item?.roleId &&
                      !params[1]?.parentId) ||
                    (item?.roleId === params[1]?.roleId &&
                      !item?.parentId &&
                      !params[1]?.parentId)
                  )
                    if (item?.appUserResource?.fieldEntityId) {
                      ids?.push(item?.appUserResource?.fieldEntityId);
                    }
                }
                if (params[1]?.parentId) {
                  if (
                    (item?.roleId === params[1]?.parentId &&
                      !params[1]?.roleId &&
                      !item?.parentId) ||
                    (item?.parentId === params[1]?.parentId &&
                      !params[1]?.roleId &&
                      !item?.roleId)
                  )
                    if (item?.appUserResource?.fieldEntityId) {
                      ids?.push(item?.appUserResource?.fieldEntityId);
                    }
                }
              }
            });
          }
          return (
            <LayoutCell
              orderType="left"
              tableSize="sm"
              className={
                params[1].parentId ? "background-color-td-child-dxg" : ""
              }
            >
              {arrAfterFilter?.length === 0 ? (
                <div
                  className="d-flex w-100"
                  style={{ flexDirection: "column" }}
                >
                  <div
                    className={
                      !model?.appUserRoles[params[2]]?.appUserResource &&
                        model?.appUserRoles[params[2]]?.parentId &&
                        // || (!model?.appUserRoles[params[2]]?.appUserResource
                        //     && model?.appUserRoles[params[2] + 1]?.parentId)
                        checkSave[params[2]] === false
                        ? "border-errors-dxg"
                        : ""
                    }
                  >
                    <div className="wrap-tool-tip-dxg">
                      {model?.appUserRoles[params[2]]?.appUserResource
                        ?.fieldEntity?.name ? (
                        <div className="tool-tip-dxg">
                          <span>
                            {
                              model?.appUserRoles[params[2]]?.appUserResource
                                ?.fieldEntity?.name
                            }
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      <Select
                        appendToBody
                        type={0}
                        classFilter={FieldModelFilter}
                        valueFilter={{
                          ...new FieldModelFilter(),
                          siteId: { equal: params[1]?.role?.siteId },
                          id: { notIn: [...ids] },
                        }}
                        placeHolder={translate(
                          "appUsers.placeholder.condition"
                        )}
                        getList={appUserRepository.singleListFieldEntity}
                        onChange={handleChangeRole(
                          params[1],
                          params[2],
                          "CONDITION"
                        )}
                        value={
                          model?.appUserRoles[params[2]]?.appUserResource
                            ?.fieldEntity
                        }
                        // Ẩn nút thêm vai trò thì thêm điều kiện này
                        // || !model?.appUserRoles[params[2]]?.parentId
                        disabled={
                          model?.appUserRoles[params[2]]?.assignmentType
                            ?.code === "SPECIFICITY"
                            ? true
                            : false
                        }
                        maxLengthItem={50}
                      />
                    </div>
                  </div>
                  {!model?.appUserRoles[params[2]]?.appUserResource &&
                    model?.appUserRoles[params[2]]?.parentId &&
                    // || (!model?.appUserRoles[params[2]]?.appUserResource
                    //     && model?.appUserRoles[params[2] + 1]?.parentId)
                    checkSave[params[2]] === false ? (
                    <span className="span-dxg-errors">Chưa chọn điều kiện</span>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div
                  className="d-flex w-100"
                  style={{ flexDirection: "column" }}
                >
                  <div
                    className={
                      !model?.appUserRoles[indexHere]?.appUserResource &&
                        model?.appUserRoles[indexHere]?.parentId &&
                        // || (!model?.appUserRoles[params[2]]?.appUserResource
                        //     && model?.appUserRoles[params[2] + 1]?.parentId)
                        checkSave[indexHere] === false
                        ? "border-errors-dxg"
                        : ""
                    }
                  >
                    <div className="wrap-tool-tip-dxg">
                      {model?.appUserRoles[indexHere]?.appUserResource
                        ?.fieldEntity?.name ? (
                        <div className="tool-tip-dxg">
                          <span>
                            {
                              model?.appUserRoles[indexHere]?.appUserResource
                                ?.fieldEntity?.name
                            }
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {/* {indexHere} */}
                      <Select
                        appendToBody
                        type={0}
                        classFilter={FieldModelFilter}
                        valueFilter={{
                          ...new FieldModelFilter(),
                          siteId: { equal: params[1]?.role?.siteId },
                          id: { notIn: [...ids] },
                        }}
                        placeHolder={translate(
                          "appUsers.placeholder.condition"
                        )}
                        getList={appUserRepository.singleListFieldEntity}
                        onChange={handleChangeRole(
                          params[1],
                          indexHere,
                          "CONDITION"
                        )}
                        value={
                          model?.appUserRoles[indexHere]?.appUserResource
                            ?.fieldEntity
                        }
                        // Ẩn nút thêm vai trò thì thêm điều kiện này
                        // || !model?.appUserRoles[params[2]]?.parentId
                        disabled={
                          model?.appUserRoles[indexHere]?.assignmentType
                            ?.code === "SPECIFICITY"
                            ? true
                            : false
                        }
                        maxLengthItem={50}
                      />
                    </div>
                  </div>
                  {!model?.appUserRoles[indexHere]?.appUserResource &&
                    model?.appUserRoles[indexHere]?.parentId &&
                    // || (!model?.appUserRoles[params[2]]?.appUserResource
                    //     && model?.appUserRoles[params[2] + 1]?.parentId)
                    checkSave[indexHere] === false ? (
                    <span className="span-dxg-errors">Chưa chọn điều kiện</span>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </LayoutCell>
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.operationCode")}
          />
        ),
        key: "appUserResource",
        dataIndex: "appUserResource",
        width: 100,
        render(...params: [any, AppUser, number]) {
          const permissionOperatorFilter = new PermissionOperatorFilter();
          permissionOperatorFilter.fieldTypeId.equal = 1;
          return (
            // <LayoutCell orderType="left" tableSize="sm">
            //   <div className="d-flex w-100" style={{ flexDirection: "column" }}>
            //     <div
            //       className={
            //         ((model.appUserRoles[params[2]]?.appUserResource
            //           ?.fieldEntity &&
            //           !model?.appUserRoles[params[2]]?.appUserResource
            //             ?.permissionOperator &&
            //           model?.appUserRoles[params[2]]?.parentId) ||
            //           (!model?.appUserRoles[params[2]]?.appUserResource
            //             ?.permissionOperator &&
            //             model?.appUserRoles[params[2]]?.appUserResource
            //               ?.fieldEntity &&
            //             !model?.appUserRoles[params[2]]?.parentId)) &&
            //           checkSave[params[2]] === false
            //           ? "border-errors-dxg"
            //           : ""
            //       }
            //     >
            //       {model?.appUserRoles[params[2]]?.appUserResource
            //         ?.fieldEntity ? (
            //         <div className="wrap-tool-tip-dxg">
            //           {model?.appUserRoles[params[2]]?.appUserResource
            //             ?.permissionOperator?.name ? (
            //             <div className="tool-tip-dxg">
            //               <span>
            //                 {
            //                   model?.appUserRoles[params[2]]?.appUserResource
            //                     ?.permissionOperator?.name
            //                 }
            //               </span>
            //             </div>
            //           ) : (
            //             ""
            //           )}
            //           <Select
            //             appendToBody
            //             valueFilter={permissionOperatorFilter}
            //             type={0}
            //             classFilter={FieldModelFilter}
            //             placeHolder={translate(
            //               "appUsers.placeholder.operationCode"
            //             )}
            //             getList={roleRepository.singleListPermissionOperator}
            //             onChange={handleChangeRole(
            //               params[1],
            //               params[2],
            //               "PERMISSIONOPERATOR"
            //             )}
            //             value={
            //               model?.appUserRoles[params[2]]?.appUserResource
            //                 ?.permissionOperator
            //             }
            //             maxLengthItem={50}
            //             disabled={
            //               model?.appUserRoles[params[2]]?.assignmentType
            //                 ?.code === "SPECIFICITY"
            //                 ? true
            //                 : false
            //             }
            //           />
            //         </div>
            //       ) : (
            //         ""
            //       )}
            //     </div>
            //     {((model?.appUserRoles[params[2]]?.appUserResource
            //       ?.fieldEntity &&
            //       !model?.appUserRoles[params[2]]?.appUserResource
            //         ?.permissionOperator &&
            //       model?.appUserRoles[params[2]]?.parentId) ||
            //       (!model?.appUserRoles[params[2]]?.appUserResource
            //         ?.permissionOperator &&
            //         model?.appUserRoles[params[2]]?.appUserResource
            //           ?.fieldEntity &&
            //         !model?.appUserRoles[params[2]]?.parentId)) &&
            //       checkSaveCode[params[2]] === false ? (
            //       <span className="span-dxg-errors">Chưa chọn mã thao tác</span>
            //     ) : (
            //       ""
            //     )}
            //   </div>
            // </LayoutCell>
            <LayoutCell
              orderType="left"
              tableSize="sm"
              className={
                params[1].parentId ? "background-color-td-child-dxg" : ""
              }
            >
              <OneLineText value={"Chứa"} countCharacters={50} />
            </LayoutCell>
          );
        },
      },
      {
        title: (
          <LayoutHeader
            orderType="left"
            title={translate("appUsers.roles.value")}
          />
        ),
        key: "appUserResource",
        dataIndex: "appUserResource",
        width: 400,
        render(...params: [any, AppUser, number]) {
          const permissionOperatorFilter = new PermissionOperatorFilter();
          permissionOperatorFilter.fieldTypeId.equal = 1;
          const indexHere = _.findIndex(model.appUserRoles, {
            rowId: params[1]?.rowId,
          });
          return (
            <div
              className={
                params[1].parentId ? "background-color-td-child-dxg" : ""
              }
            >
              <LayoutCell orderType="left" tableSize="sm">
                {arrAfterFilter?.length === 0 ? (
                  <Tooltip
                    title={model?.appUserRoles[
                      params[2]
                    ]?.appUserResource?.masterDatas
                      ?.map((item: any) => item.title)
                      ?.toString()}
                    placement="leftTop"
                  >
                    <div
                      className="d-flex w-100"
                      style={{ flexDirection: "column" }}
                    >
                      <div
                        className={
                          ((model?.appUserRoles[params[2]]?.appUserResource
                            ?.fieldEntity &&
                            model?.appUserRoles[params[2]]?.appUserResource
                              ?.masterDatas?.length < 0 &&
                            model?.appUserRoles[params[2]]?.parentId) ||
                            (model?.appUserRoles[params[2]]?.appUserResource
                              ?.fieldEntity &&
                              model?.appUserRoles[params[2]]?.appUserResource
                                ?.masterData?.length < 0 &&
                              !model?.appUserRoles[params[2]]?.parentId)) &&
                            checkSave[params[2]] === false
                            ? "tree-dxg errors-here-dxg"
                            : "tree-dxg"
                        }
                        style={{
                          opacity: model?.appUserRoles[params[2]]?.assignmentType?.code === "SPECIFICITY" ? 0.6 : 1
                        }}
                      >
                        {/* // Dữ liệu chính là dataValueStandardTable là mảng ta đã sử dụng useEffect để tạo ra mảng chứa tất cả những select của thằng
                      // TreeSelect chọn nhiều hay Multi Select
                      // Và selectDataTreeNotConvert đây cũng là mảng chứa tất cả dữ liệu của TreeSelect chọn nhiều hay Multi Select
                      // nhưng phần dữ liệu cnủa treeSelect sẽ không convert để phục vụ cho việc onchange giá trị */}

                        {model?.appUserRoles[params[2]]?.appUserResource
                          ?.fieldEntity ? (
                          model?.appUserRoles[params[2]]?.appUserResource
                            ?.fieldEntity?.fieldName ===
                            "BusinessAreaOrganizationId" ||
                            model?.appUserRoles[params[2]]?.appUserResource
                              ?.fieldEntity?.fieldName === "OrganizationId" ? (
                            <TreeSelect
                              showSearch
                              treeNodeFilterProp="title"
                              treeData={dataValueStandardTable[params[2]]}
                              onChange={onChangeTreeSelect(
                                params[2],
                                params[1]
                              )}
                              className="w-100 mt-1"
                              allowClear
                              treeDefaultExpandAll
                              multiple
                              value={model?.appUserRoles[
                                params[2]
                              ]?.appUserResource?.masterDatas?.map(
                                (item: any) => item.id
                              )}
                              // value={arrValueShow}
                              maxTagCount={2}
                              disabled={
                                model?.appUserRoles[params[2]]?.assignmentType?.code === "SPECIFICITY"
                                  ? true
                                  : false
                              }
                              treeCheckable={true}
                              showCheckedStrategy={"SHOW_PARENT"}
                            />
                          ) : (
                            <SelectAntd
                              value={
                                model?.appUserRoles[params[2]]?.appUserResource
                                  ?.masterDatas
                                  ? model?.appUserRoles[params[2]]
                                    ?.appUserResource?.masterDatas
                                  : undefined
                              }
                              mode="multiple"
                              options={
                                arrAppUserResourceDataFilter[params[2]]
                                  ?.length > 0
                                  ? arrAppUserResourceDataFilter[params[2]]
                                  : dataValueStandardTable[params[2]]
                              }
                              onChange={onChangeAppUserResourceDataFilter(
                                params[2],
                                model
                              )}
                              onSearch={onSearchAppUserResourceDataFilter(
                                params[2],
                                model
                              )}
                              filterOption={false}
                              className="w-100"
                              allowClear
                              dropdownStyle={
                                isLoading ? { display: "none" } : {}
                              }
                              disabled={
                                model?.appUserRoles[params[2]]?.assignmentType?.code === "SPECIFICITY"
                                  ? true
                                  : false
                              }
                              tagRender={(props) => {
                                const masterDatas = model?.appUserRoles[params[2]]?.appUserResource?.masterDatas || [];
                                let currentItem = masterDatas.find((item: any) =>
                                  item.value === props.value ||
                                  item.id === props.value ||
                                  item.key === props.value
                                );
                                if (!currentItem && typeof props.value === 'object') {
                                  currentItem = props.value;
                                }
                                const isEditable = currentItem?.editable !== false;
                                return (
                                  <Tag
                                    closable={isEditable && props.closable}
                                    onClose={props.onClose}
                                    style={{
                                      marginTop: 3,
                                      marginRight: 3,
                                      marginBottom: 3,
                                      marginLeft: 3,
                                      opacity: isEditable ? 1 : 0.6,
                                      backgroundColor: isEditable ? undefined : '#f5f5f5',
                                      borderColor: isEditable ? undefined : '#d9d9d9',
                                      color: isEditable ? undefined : '#8c8c8c',
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      fontSize: 'inherit',
                                      lineHeight: 'inherit',
                                    }}
                                  >
                                    {props.label}
                                  </Tag>
                                );
                              }}
                              maxTagCount={2}
                            ></SelectAntd>
                          )
                        ) : (
                          ""
                        )}
                      </div>
                      {((model.appUserRoles[params[2]]?.appUserResource
                        ?.fieldEntity &&
                        model?.appUserRoles[params[2]]?.appUserResource
                          ?.masterDatas?.length < 0 &&
                        model?.appUserRoles[params[2]]?.parentId) ||
                        (model?.appUserRoles[params[2]]?.appUserResource
                          ?.fieldEntity &&
                          model?.appUserRoles[params[2]]?.appUserResource
                            ?.masterDatas?.length < 0 &&
                          !model?.appUserRoles[params[2]]?.parentId)) &&
                        checkSave[params[2]] === false ? (
                        <span className="span-dxg-errors">
                          Chưa chọn giá trị
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </Tooltip>
                ) : (
                  <Tooltip
                    title={model?.appUserRoles[
                      indexHere
                    ]?.appUserResource?.masterDatas
                      ?.map((item: any) => item.title)
                      ?.toString()}
                    placement="leftTop"
                  >
                    <div
                      className="d-flex w-100"
                      style={{ flexDirection: "column" }}
                    >
                      <div
                        className={
                          ((model?.appUserRoles[indexHere]?.appUserResource
                            ?.fieldEntity &&
                            model?.appUserRoles[indexHere]?.appUserResource
                              ?.masterDatas?.length < 0 &&
                            model?.appUserRoles[indexHere]?.parentId) ||
                            (model?.appUserRoles[indexHere]?.appUserResource
                              ?.fieldEntity &&
                              model?.appUserRoles[indexHere]?.appUserResource
                                ?.masterData?.length < 0 &&
                              !model?.appUserRoles[indexHere]?.parentId)) &&
                            checkSave[indexHere] === false
                            ? "tree-dxg errors-here-dxg"
                            : "tree-dxg"
                        }
                        style={{
                          opacity: model?.appUserRoles[indexHere]?.assignmentType?.code === "SPECIFICITY" ? 0.6 : 1
                        }}
                      >
                        {/* // Dữ liệu chính là dataValueStandardTable là mảng ta đã sử dụng useEffect để tạo ra mảng chứa tất cả những select của thằng
                          // TreeSelect chọn nhiều hay Multi Select
                          // Và selectDataTreeNotConvert đây cũng là mảng chứa tất cả dữ liệu của TreeSelect chọn nhiều hay Multi Select
                          // nhưng phần dữ liệu của treeSelect sẽ không convert để phục vụ cho việc onchange giá trị */}

                        {model?.appUserRoles[indexHere]?.appUserResource
                          ?.fieldEntity ? (
                          model?.appUserRoles[indexHere]?.appUserResource
                            ?.fieldEntity?.fieldName ===
                            "BusinessAreaOrganizationId" ||
                            model?.appUserRoles[indexHere]?.appUserResource
                              ?.fieldEntity?.fieldName === "OrganizationId" ? (
                            <div>
                              {/* {model?.appUserRoles[
                                indexHere
                              ]?.appUserResource?.masterDatas?.map(
                                (item: any) => item.id
                              )} */}
                              <TreeSelect
                                showSearch
                                treeNodeFilterProp="title"
                                treeData={dataValueStandardTable[indexHere]}
                                onChange={onChangeTreeSelect(
                                  indexHere,
                                  params[1]
                                )}
                                className="w-100 mt-1"
                                allowClear
                                treeDefaultExpandAll
                                multiple
                                value={model?.appUserRoles[
                                  indexHere
                                ]?.appUserResource?.masterDatas?.map(
                                  (item: any) => item.id
                                )}
                                // value={arrValueShow}
                                maxTagCount={2}
                                disabled={
                                  model?.appUserRoles[indexHere]?.assignmentType?.code === "SPECIFICITY"
                                    ? true
                                    : false
                                }
                                treeCheckable={true}
                                showCheckedStrategy={"SHOW_PARENT"}
                              />
                            </div>
                          ) : (
                            <div>
                              <SelectAntd
                                value={
                                  model?.appUserRoles[indexHere]
                                    ?.appUserResource?.masterDatas
                                    ? model?.appUserRoles[indexHere]
                                      ?.appUserResource?.masterDatas
                                    : undefined
                                }
                                mode="multiple"
                                options={
                                  arrAppUserResourceDataFilter[indexHere]
                                    ?.length > 0
                                    ? arrAppUserResourceDataFilter[indexHere]
                                    : dataValueStandardTable[indexHere]
                                }
                                onChange={onChangeAppUserResourceDataFilter(
                                  indexHere,
                                  model
                                )}
                                onSearch={onSearchAppUserResourceDataFilter(
                                  indexHere,
                                  model
                                )}
                                filterOption={false}
                                className="w-100"
                                allowClear
                                dropdownStyle={
                                  isLoading ? { display: "none" } : {}
                                }
                                disabled={
                                  model?.appUserRoles[indexHere]?.assignmentType?.code === "SPECIFICITY"
                                    ? true
                                    : false
                                }
                                tagRender={(props) => {
                                  const masterDatas = model?.appUserRoles[indexHere]?.appUserResource?.masterDatas || [];
                                  let currentItem = masterDatas.find((item: any) =>
                                    item.value === props.value ||
                                    item.id === props.value ||
                                    item.key === props.value
                                  );
                                  if (!currentItem && typeof props.value === 'object') {
                                    currentItem = props.value;
                                  }
                                  const isEditable = currentItem?.editable !== false;
                                  return (
                                    <Tag
                                      closable={isEditable && props.closable}
                                      onClose={props.onClose}
                                      style={{
                                        marginRight: 3,
                                        marginBottom: 3,
                                        opacity: isEditable ? 1 : 0.6,
                                        backgroundColor: isEditable ? undefined : '#f5f5f5',
                                        borderColor: isEditable ? undefined : '#d9d9d9',
                                        color: isEditable ? undefined : '#8c8c8c',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        fontSize: 'inherit',
                                        lineHeight: 'inherit',
                                      }}
                                    >
                                      {props.label}
                                    </Tag>
                                  );
                                }}
                                maxTagCount={2}
                              ></SelectAntd>
                            </div>
                          )
                        ) : (
                          ""
                        )}
                      </div>
                      {((model?.appUserRoles[indexHere]?.appUserResource
                        ?.fieldEntity &&
                        model?.appUserRoles[indexHere]?.appUserResource
                          ?.masterDatas?.length < 0 &&
                        model?.appUserRoles[indexHere]?.parentId) ||
                        (model?.appUserRoles[indexHere]?.appUserResource
                          ?.fieldEntity &&
                          model?.appUserRoles[indexHere]?.appUserResource
                            ?.masterDatas?.length < 0 &&
                          !model?.appUserRoles[indexHere]?.parentId)) &&
                        checkSave[indexHere] === false ? (
                        <span className="span-dxg-errors">
                          Chưa chọn giá trị
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </Tooltip>
                )}
              </LayoutCell>
            </div>
          );
        },
      },

      {
        title: translate("general.actions.label"),
        key: "action",
        dataIndex: nameof(model[0].id),
        fixed: "right",
        width: 80,
        align: "center",
        render(...params: [any, AppUser, number]) {
          const indexHere = _.findIndex(model.appUserRoles, {
            rowId: params[1]?.rowId,
          });
          return (
            <div
              className={
                params[1].parentId
                  ? "d-flex justify-content-center button-action-table missions-dxg background-color-f0-child-dxg"
                  : "d-flex justify-content-center button-action-table missions-dxg"
              }
            >
              {arrAfterFilter?.length === 0 ? (
                !params[1].parentId ? (
                  model?.appUserRoles[params[2]]?.assignmentType?.code ===
                    "SPECIFICITY" ? (
                    <div className="disable-dxg">
                      <Add24 />
                    </div>
                  ) : (
                    <Tooltip title={translate("appUsers.roles.action.add")}>
                      <div className="enable-dxg w-100">
                        <Add24
                          className="btn-missions-blue"
                          onClick={() => {
                            handleAddRow(params[2], params[0], params[1]);
                          }}
                        />
                      </div>
                    </Tooltip>
                  )
                ) : (
                  ""
                )
              ) : !params[1].parentId ? (
                model?.appUserRoles[indexHere]?.assignmentType?.code ===
                  "SPECIFICITY" ? (
                  <div className="disable-dxg">
                    <Add24 />
                  </div>
                ) : (
                  <Tooltip title={translate("appUsers.roles.action.add")}>
                    <div className="enable-dxg w-100">
                      <Add24
                        className="btn-missions-blue"
                        onClick={() => {
                          handleAddRow(indexHere, params[0], params[1]);
                        }}
                      />
                    </div>
                  </Tooltip>
                )
              ) : (
                ""
              )}
              {params[1].parentId ? (
                <div className="enable-dxg">
                  <Popconfirm
                    placement="top"
                    title={translate("general.deletes.content")}
                    onConfirm={() => {
                      handleDeleteRow(
                        arrAfterFilter?.length === 0 ? params[2] : indexHere,
                        params[1]
                      );
                    }}
                    okText={translate("general.actions.delete")}
                    cancelText={translate("general.actions.cancel")}
                  >
                    <Tooltip title={translate("appUsers.roles.action.delete")}>
                      <div className="w-100">
                        <Delete24 className="btn-missions-red" />
                      </div>
                    </Tooltip>
                  </Popconfirm>
                </div>
              ) : (
                ""
              )}
            </div>
          );
        },
      },
    ],
    [
      checkSave,
      handleAddRow,
      handleChangeRole,
      handleDeleteRow,
      model,
      translate,
      onChangeTreeSelect,
      dataValueStandardTable,
      onChangeAppUserResourceDataFilter,
      onSearchAppUserResourceDataFilter,
      arrAppUserResourceDataFilter,
      isLoading,
      arrAfterFilter,
    ]
  );

  return (
    <Spin spinning={isLoading}>
      <div className="page-content page-content-dxg" id="page-content-dxg-id">
        <div className="info-component ml-4 mb-3">
          <span>{translate("appUsers.master.header")}</span>
          <span> &gt; </span>
          <span className="info-primary">
            {translate("appUsers.master.permissionsHeader")}
          </span>
        </div>

        <div className="page p-t--lg p-l--md p-r--sm p-b--lg background-white-dxg">
          <div className="mb-0 d-flex justify-content-between background-w-dxg border-tl-8-dxg">
            <h5 className="font-bold page-title">
              {translate("appUsers.master.subHeader")}
            </h5>
            <div className="mr-3">
              <Button
                type="secondary"
                className="btn--lg btn-red"
                icon={<Close16 />}
                onClick={handleGoMaster}
              >
                {translate("general.actions.close")}
              </Button>
              <Button
                type="secondary"
                className="btn--lg btn-orange-export ml-3"
                icon={<Time16 />}
                onClick={handleGoHistory(model?.id)}
              >
                {translate("general.actions.viewHistory")}
              </Button>
              {validAction("updateResource") && (
                <Button
                  type="primary"
                  className="btn--lg btn-orange-wIcon ml-3"
                  icon={<Send16 />}
                  onClick={handleSaveModelHere}
                >
                  {translate("general.actions.save")}
                </Button>
              )}
            </div>
          </div>
        </div>

        <div className="page page-detail p-l--md p-r--sm border-tl-dxg-0 border-tr-dxg-0">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col lg={24} className="m-b--xs">
              <Row className="align-item__center">
                <div className="text__with__label__header">
                  <span>
                    {!isDetail
                      ? translate("general.actions.create")
                      : translate("general.detail.title")}
                  </span>
                </div>
                <Button
                  type="icon-only-ghost"
                  icon={showDetail ? <ChevronDown16 /> : <ChevronUp16 />}
                  onClick={() => setShowDetail(!showDetail)}
                  className="btn--xl btn-grey"
                />
              </Row>
            </Col>
          </Row>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className={`${classNames({
              displayNone: !showDetail,
            })} general-input-custom`}
          >
            <Col lg={24} className="m-b--xxs p-r--sm">
              <Row>
                <Col lg={6} className="m-b--xxs p-r--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.username)
                    )}
                    message={model?.errors?.username}
                  >
                    <InputText
                      label={translate("appUsers.username")}
                      type={0}
                      value={model.username}
                      placeHolder={translate("appUsers.placeholder.username")}
                      className={"tio-account_square_outlined"}
                      onChange={handleChangeSingleField({
                        fieldName: nameof(model.username),
                      })}
                      disabled={true}
                    />
                  </FormItem>
                </Col>
                <Col lg={6} className="m-b--xxs p-r--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.displayName)
                    )}
                    message={model?.errors?.displayName}
                  >
                    <InputText
                      label={translate("appUsers.displayName")}
                      type={0}
                      value={model?.displayName}
                      placeHolder={translate(
                        "appUsers.placeholder.displayName"
                      )}
                      className={"tio-account_square_outlined"}
                      onChange={handleChangeSingleField({
                        fieldName: nameof(model.displayName),
                      })}
                      disabled={true}
                    />
                  </FormItem>
                </Col>
                <Col lg={6} className="m-b--xxs p-r--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.referenceCode)
                    )}
                    message={model?.errors?.referenceCode}
                  >
                    <InputText
                      label={translate("appUsers.employeeCode")}
                      type={0}
                      value={model?.referenceCode}
                      placeHolder={translate(
                        "appUsers.placeholder.employeeCode"
                      )}
                      className={"tio-account_square_outlined"}
                      onChange={handleChangeSingleField({
                        fieldName: nameof(model.referenceCode),
                      })}
                      disabled={true}
                    />
                  </FormItem>
                </Col>
                <Col lg={6} className="m-b--xxs p-r--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.birthday)
                    )}
                    message={model?.errors?.birthday}
                  >
                    <DatePicker
                      label={translate("appUsers.birthday")}
                      value={model?.birthday}
                      type={0}
                      onChange={handleChangeDateField({
                        fieldName: nameof(model.birthday),
                      })}
                      // disabledDate={(current) => {
                      //   return current && current > moment().endOf("day");
                      // }}
                      placeholder={translate("appUsers.placeholder.birthday")}
                      disabled={true}
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col lg={6} className="m-b--xxs p-r--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.address)
                    )}
                    message={model?.errors?.address}
                  >
                    <InputText
                      label={translate("appUsers.address")}
                      type={0}
                      value={model?.address}
                      placeHolder={translate("appUsers.placeholder.address")}
                      className={"tio-account_square_outlined"}
                      onChange={handleChangeSingleField({
                        fieldName: nameof(model.address),
                      })}
                      disabled={true}
                    />
                  </FormItem>
                </Col>
                <Col lg={6} className="m-b--xxs p-r--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.email)
                    )}
                    message={model?.errors?.email}
                  >
                    <InputText
                      label={translate("appUsers.email")}
                      type={0}
                      value={model?.email}
                      placeHolder={translate("appUsers.placeholder.email")}
                      className={"tio-account_square_outlined"}
                      onChange={handleChangeSingleField({
                        fieldName: nameof(model.email),
                      })}
                      disabled={true}
                    />
                  </FormItem>
                </Col>
                <Col lg={6} className="m-b--xxs p-r--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.phone)
                    )}
                    message={model?.errors?.phone}
                  >
                    <InputText
                      label={translate("appUsers.phone")}
                      type={0}
                      value={model?.phone}
                      placeHolder={translate("appUsers.placeholder.phone")}
                      className={"tio-account_square_outlined"}
                      onChange={handleChangeSingleField({
                        fieldName: nameof(model.phone),
                      })}
                      disabled={true}
                    />
                  </FormItem>
                </Col>
                <Col lg={6} className="m-b--xxs p-r--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.organization)
                    )}
                    message={model?.errors?.organization}
                  >
                    <TreeReact3l
                      label={translate("appUsers.organization")}
                      type={0}
                      placeHolder={translate(
                        "appUsers.placeholder.organization"
                      )}
                      selectable={true}
                      classFilter={OrganizationFilter}
                      onChange={handleChangeTreeField({
                        fieldName: nameof(model.organization),
                      })}
                      checkStrictly={true}
                      getTreeData={appUserRepository?.singleListOrganization}
                      item={model?.organization}
                      disabled={true}
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col lg={6} className="m-b--xxs p-r--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.businessArea)
                    )}
                    message={model?.errors?.businessArea}
                  >
                    <InputText
                      label={translate("appUsers.businessArea")}
                      type={0}
                      value={model?.businessArea?.name}
                      className={"tio-account_square_outlined"}
                      disabled={true}
                    />
                  </FormItem>
                </Col>
                <Col lg={6} className="m-b--xxs p-r--sm">
                  <FormItem
                    validateStatus={utilService?.getValidateStatus(
                      model,
                      nameof(model.sex)
                    )}
                    message={model?.errors?.sex}
                  >
                    <Select
                      label={translate("appUsers.sex")}
                      type={0}
                      classFilter={SexFilter}
                      searchProperty={"name"}
                      placeHolder={translate("appUsers.placeholder.sex")}
                      getList={appUserRepository.singleListSex}
                      onChange={handleChangeSelectField({
                        fieldName: nameof(model.sex),
                      })}
                      value={model.sex}
                      disabled={true}
                    />
                  </FormItem>
                </Col>
                <Col lg={6} className="m-b--xxs p-r--sm">
                  <FormItem
                    validateStatus={utilService.getValidateStatus(
                      model,
                      nameof(model.status)
                    )}
                    message={model?.errors?.status}
                  >
                    <div>
                      <div className="label-status">
                        {translate("appUsers.status")}
                      </div>
                      <Switch
                        checked={model?.statusId === 1 ? true : false}
                        onChange={handleChangeStatus}
                        className="switch_status"
                        disabled={true}
                      />
                    </div>
                  </FormItem>
                </Col>
              </Row>
            </Col>
          </Row>

          <Tabs defaultActiveKey={"1"} className="tab-dxg">
            <TabPane key={"1"} tab={translate("appUsers.sitePermission")}>
              <div className="px-1 mt-3">
                {appUserSiteMappings?.length > 0 &&
                  appUserSiteMappings?.map(
                    (appUserSiteMapping: AppUserSiteMapping, index: number) => (
                      <div key={index} className="m-t--sm">
                        {appUserSiteMapping?.siteId !== 100 && (
                          <Row>
                            <Col span={4}>{appUserSiteMapping?.site?.name}</Col>
                            <Col>
                              <Switch
                                checked={appUserSiteMapping?.enabled === true}
                                onChange={handleChangeSiteMapping(index)}
                              />
                            </Col>
                          </Row>
                        )}
                      </div>
                    )
                  )}
              </div>
            </TabPane>
            <TabPane key={"2"} tab={translate("appUsers.sitePermission.role")}>
              <div className="px-1 mt-3">
                <div>
                  <SelectAntd
                    value={selectedCode}
                    showSearch
                    style={{ width: 220 }}
                    options={arrFilterRoleCode}
                    allowClear
                    onChange={(value) => {
                      setSelectedCode(value); // Update the selected code state
                      handleChangeSelectSearch("code")(value); // Call your existing handler
                    }}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder={"Chọn vai trò để tìm kiếm"}
                    onClear={() => {
                      // Clear the value here
                      handleChangeSelectSearch("code")(undefined); // or set to an empty string
                    }}
                  ></SelectAntd>
                  <SelectAntd
                    value={selectedSite}
                    showSearch
                    style={{ width: 220 }}
                    options={arrFilterRoleSite}
                    allowClear
                    onChange={(value) => {
                      setSelectedSite(value); // Update the selected code state
                      handleChangeSelectSearch("site")(value); // Call your existing handler
                    }}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    placeholder={"Chọn phân hệ để tìm kiếm"}
                    className="ml-2"
                    onClear={() => {
                      // Clear the value here
                      handleChangeSelectSearch("site")(undefined); // or set to an empty string
                    }}
                  ></SelectAntd>
                </div>
                {/* Temporary commented out - not in use yet */}
                <div className="d-flex justify-content-end">
                  <Button
                    type="primary"
                    className="btn--lg btn-orange-export ml-3"
                    icon={<Send16 />}
                    onClick={handleOpenRoleView}
                  >
                    Thêm vai trò
                  </Button>
                </div>
                <StandardTable
                  key={arrAfterFilter?.length}
                  rowKey={"rowId"}
                  columns={columns}
                  isDragable={true}
                  tableSize={"md"}
                  dataSource={
                    arrAfterFilter?.length === 0
                      ? model?.appUserRoles
                      : arrAfterFilter
                  }
                  className="tableDecentralization"
                />
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
      {isOpenModal && (
        <AppUserPermissionModal
          model={model}
          isOpenRoleModel={isOpenModal}
          handleCloseRoleModel={handleCloseRoleView}
          onSave={handleSaveRole}
          translate={translate}
          checkArrModalEmpty={checkArrModalEmpty}
          setCheckArrModalEmpty={setCheckArrModalEmpty}
        />
      )}
    </Spin>
  );
}

export default AppUserPermission;
